import React from 'react';
import { useParams } from 'react-router-dom';
import ThreadList from '../components/ThreadList';
import { decodeFolderKey } from '../utils/imapPaths';

export default function FolderPage() {
  const { accountId, folderKey } = useParams<{ accountId: string; folderKey: string }>();
  const account = accountId ? parseInt(accountId, 10) : undefined;
  let imapFolder = '';
  let title = 'Folder';
  try {
    imapFolder = folderKey ? decodeFolderKey(folderKey) : '';
    title = imapFolder.split(/[./]/).pop() || imapFolder || 'Folder';
  } catch {
    imapFolder = '';
  }

  return <ThreadList accountId={account} imapFolder={imapFolder} title={title} />;
}
